/**
 * Created by admin on 2017/7/25.
 */
import $ from "jquery"
import {util} from './util'
// 定义变量
//弹框元素
var $showLoginModal = $('.showLoginModal');
var $close;
//登录注册切换部分
var $userTitle;
//注册部分
var $userQQ;
var $yzmImg;
var $yzmString;
var $submitBtn;
var random = $.arc4random(10000);
var yzmUrl = util.api('IMGVERIFYCODE');
var REGISTER = util.api('REGISTBYQQ');
var checkqq = "a";
var checkyzm = "a";
//登录部分
var $loginQQ;
var $loginPwd;
var $loginBtn;
var random = $.arc4random(10000);
var yzmUrl = util.api('IMGVERIFYCODE');
var LOGIN = util.api('LOGIN');
var checkloginpwd = "a";
var checkloginqq = "a";
//索密码
var $forgetPwd;
var FINDPASSBYMAIL = util.api('FINDPASSBYMAIL');
//绑定手机
var $boundPhone;
var checkphone = "a";
var $yzmBtn;
var REGISTVERIFYCODE = util.api('REGISTVERIFYCODE');
var BOUNDPHONE = util.api('BOUNDPHONE');
var fn = {
    variables:{
        registQQ:checkqq,
        yzm:checkyzm,
        loginQQ:checkloginqq,
        pwd:checkloginpwd
    },
    showModal(){
        $.modal('close');
        $.modal('pop',
            ` <div class="user_modal">
                <div class="user_title">
                  <span class="user_title_login on">登录</span>
                  <span class="user_title_regist">注册</span>
                  <i></i>
                </div>
                <div class="user_content">
                  <div class="login tag on">
                    <p class="error_login_qq warn"></p>
                    <input class="long_input mb28 loginQQ" type="text" name="username" placeholder="请输入您的QQ号">
                    <p class="error_login_pwd warn top100"></p>
                    <input class="long_input mb20 loginPwd" type="password" name="password" placeholder="请输入密码">
                    <div class="checkbox mb20">
                      <input class="remember" type="checkbox"> <span>记住账号</span>
                    </div>
                    <button class="loginBtn">登录</button>
                    <ul>
                      <li>
                        <a href="javascript:;" class="forgetPwd">
                          <div class="dot"></div> 老客户索密
                          <div class="tips">
                               老客户是在深度交易过的老客户，老客户无需注册，索密后登录
                               <div class="arrow">
                                    <div class="arrow_in"></div>
                               </div>
                          </div>
                        </a>
                        <span>|</span>
                      </li>
                      <li class="forget_title">
                        <a href="javascript:;">忘记密码？</a>
                      </li>
                    </ul>
                  </div>
                  <div class="regist tag">
                    <p class="warn error_user_qq"></p>
                    <input class="long_input mb28 userQQ" type="text" name="username" placeholder="请输入您的QQ号">
                     <p class="warn error_yzm top100"></p>
                    <input class="short_input yzmString" type="text" name="username" placeholder="输入右边验证码">
                    <div class="yzm yzmImg">
                      <img src="" alt="">
                    </div>
                    <button class="registButton submitBtn">一键注册</button>
                    <p class="toLogin">老客户登录</p>
                  </div>
            </div>
            </div>`);
        // fn.initYzmImg();
        fn.tab();
        $close = $('.user_title').find('i');
        $close.click(function () {
            fn.closeModal();
        });
        // 注册验证
        fn.checkQQ();
        fn.checkYzm();
        // 点击注册
        $submitBtn = $('.submitBtn');
        $submitBtn.on('click', function(){
            if(checkqq == true && checkyzm == true){
                fn.postRegister();
            }else {
                $('.error_user_qq').html(`<i></i>请输入相关内容`);
            }
        });
        //点击跳转登录
        $('.toLogin').click(function () {
            fn.initYzmImg();
            $('.user_title_regist').removeClass('on');
            $('.user_title_login').addClass('on');
            $('.user_content .regist').removeClass('on');
            $('.user_content .login').addClass('on');
        });
        // 登录验证
        fn.checkLoginQQ();
        fn.checkPwd();
        // 点击登录
        $loginBtn = $('.loginBtn');
        $loginBtn.on('click', function(){
            if(checkloginqq && checkloginpwd){
                fn.postLogin();
            }
            if(checkloginqq == "a" && checkloginpwd == "a") {
                $('.error_login_qq').html(`<i></i>请输入相关内容`);
            }
        });
        //点击索密
        $forgetPwd = $('.forgetPwd');
        $forgetPwd.on('click',function () {
            fn.findPwd();
        });
        //点击忘记密码
        $('.forget_title').click(function () {
            fn.findPwd('忘记密码');
        });
        //验证码更新
        $yzmImg = $('.yzmImg');
        $yzmImg.click(function () {
           fn.freshYzm();
        })
    },
    closeModal(){
      $.modal('close');
    },
    tab(){
        $userTitle = $('.user_title');
        $userTitle.find('span').click(function () {
            fn.freshYzm();
            $userTitle.find('span').removeClass('on');
            $(this).addClass('on');
            $('.user_content>div').removeClass('on');
            $('.user_content>div').eq($(this).addClass('on').index()).addClass('on');
        })
    },
    initYzmImg:function () {
        var src = yzmUrl+'?'+random;
        $yzmImg = $('.yzmImg img');
        $yzmImg.attr('src',src);
    },
    freshYzm:function () {
        random = $.arc4random(10000);
        fn.initYzmImg();
    },
    checkQQ:function(){
        $userQQ = $('.userQQ');
        $userQQ.on('blur', function(){
            var qq = $userQQ.val();
            if(qq == ""){
                $('.error_user_qq').html(`<i></i>请输入QQ号码`);
                $userQQ.addClass('shadow');
                checkqq = false;
                return;
            }else if(!/^[1-9]([0-9]{5,11})$/.test(qq)){
                $('.error_user_qq').html(`<i></i>请输入正确的QQ号码`);
                $userQQ.addClass('shadow');
                checkqq = false;
                return;
            }else {
                $('.error_user_qq').html('');
                $userQQ.removeClass('shadow');
                checkqq = true;
            }
            fn.variables.registQQ = checkqq;
        });
    },
    checkYzm:function () {
        $yzmString = $('.yzmString');
        $yzmString.on('blur',function () {
            var yzmString = $yzmString.val();
            if(yzmString == ""){
                $('.error_yzm').html("<i></i>请输入验证码");
                $yzmString.addClass('shadow');
                checkyzm = false;
                return;
            }else if(!/^[0-9A-Za-z]{4}$/.test(yzmString)){
                $('.error_yzm').html("<i></i>请输入正确的验证码");
                $yzmString.addClass('shadow');
                checkyzm = false;
                return;
            }else{
                $('.error_yzm').html('');
                $yzmString.removeClass('shadow');
                checkyzm = true;
            }
            fn.variables.yzm = checkyzm;
        });
    },
    checkLoginQQ:function(){
        $loginQQ = $('.loginQQ');
        $loginQQ.on('blur', function(){
            var qq = $loginQQ.val();
            if(qq == ""){
                $('.error_login_qq').html(`<i></i>请输入QQ号码`);
                $loginQQ.addClass('shadow');
                return;
            }else if(!/^[1-9]([0-9]{5,11})$/.test(qq)){
                $('.error_login_qq').html(`<i></i>请输入正确的QQ号码`);
                $loginQQ.addClass('shadow');
                return;
            }else {
                $('.error_login_qq').html('');
                $loginQQ.removeClass('shadow');
                checkloginqq = true;
            }
            fn.variables.loginQQ = checkloginqq;
        });
    },
    checkPwd:function () {
        $loginPwd = $('.loginPwd');
        $loginPwd.on('blur',function () {
            var pwd = $loginPwd.val();
            if(pwd == ""){
                $('.error_login_pwd').html(`<i></i>密码不能为空`);
                $loginPwd.addClass('shadow');
                checkloginpwd = false;
            }else {
                $('.error_login_pwd').html(``);
                $loginPwd.removeClass('shadow');
                checkloginpwd = true;
            }
            fn.variables.pwd = checkloginpwd;
        });
    },
    checkPhone(){
        $boundPhone = $('.boundPhone');
        $boundPhone.on('blur',function () {
            var phone = $boundPhone.val();
            if(phone == ""){
                $('.error_phone').html(`<i></i>手机号码不能为空`);
                $boundPhone.addClass('shadow');
                checkphone = false;
            }else if(!/^1(3|5|4|7|8)\d{9}$/.test(phone)){
                $('.error_phone').html(`<i></i>请输入正确的手机号码`);
                $boundPhone.addClass('shadow');
                checkphone = false;
            }else {
                $('.error_phone').html(``);
                $boundPhone.removeClass('shadow');
                checkphone = true;
            }
        });
    },
    checkCode(){
        $yzmString = $('.yzmString');
        $yzmString.on('blur',function () {
            var yzmString = $yzmString.val();
            if(yzmString == ""){
                $('.error_yzm').html("<i></i>请输入验证码");
                $yzmString.addClass('shadow');
                checkyzm = false;
                return;
            }else{
                $('.error_yzm').html('');
                $yzmString.removeClass('shadow');
                checkyzm = true;
            }
            fn.variables.yzm = checkyzm;
        });
    },
    findPwd(a){
        $.modal('close');
        $.modal('pop',
            `<div class="user_modal">
                <div class="user_title">
                    <p>老客户索密</p>
                    <i></i>
                  </div>
                  <div class="user_content suomi">
                    <p class="warn error_user_qq"></p>
                    <input class="long_input mb28 userQQ" type="text" name="username" placeholder="请输入您的QQ号">
                    <p class="warn error_yzm top100"></p>
                    <input class="short_input yzmString" type="text" placeholder="输入右边验证码">
                    <div class="yzm yzmImg">
                      <img src="" alt="">
                    </div>
                    <button class="submitBtn">提交</button>
                    <div class="alert">
                      密码已发送到你的QQ邮箱，请注意查收。登录后可进行修改。
                    </div>
                    <p class="back">返回登录</p>
                 </div>   
            </div>`
        );
        //设置标题
        if(a){
            $('.user_title p').html('忘记密码')
        }
        fn.freshYzm();
        //关闭
        $close = $('.user_title i');
        $close.click(function () {
            $.modal('close');
        });
        //验证码更新
        $yzmImg = $('.yzmImg');
        $yzmImg.click(function () {
            fn.freshYzm();
        });
        //表单验证
        fn.checkQQ();
        fn.checkYzm();
        //点击提交
        $submitBtn = $('.submitBtn');
        $submitBtn.click(function () {
            if(checkqq && checkyzm){
                fn.postFindPwd();
            }
            if(checkqq == "a" && checkyzm == "a") {
                $('.error_user_qq').html(`<i></i>请输入相关内容`);
            }
        });
        //返回登录
        $('.back').click(function () {
            $.modal('close');
            fn.showModal();
        })
    },
    boundPhone(){
        $.modal('pop',
            `<div class="user_modal" style="height: 485px;">
              <div class="user_title">
                <p>绑定手机</p>
                <i></i>
              </div>
              <div class="user_content bound">
                <p class="remind">根据《中华人民共和国网络安全法》要求，使用信息发布、即时通讯等互联网服务需要进行身份信息验证。为保障您的使用体验
                   建议您尽快完成手机号绑定验证，感谢您的支持和理解。
                </p>
                <p class="warn error_phone"></p>
                <input class="long_input mb28 boundPhone" type="text" name="username" placeholder="请输入您的手机号码">
                <p class="warn error_yzm top100"></p>
                <input class="short_input mb28 yzmString" type="text" name="username" placeholder="输入验证码">
                <div class="yzmBtn">
                  发送验证码
                </div>
                <button class="boundPhoneBtn">确认</button>
                <div class="alert">
                  密码已发送到你的QQ邮箱，请注意查收。登录后可进行修改。
                </div>
              </div>
            </div>`
        );
        fn.checkPhone();
        fn.checkCode();
        //点击发送验证码
        $yzmBtn = $('.yzmBtn');
        $yzmBtn.click(function() {
            if (checkphone == true) {
                fn.postCode();
            } else {
                $('.error_phone').html('<i></i>请输入正确的手机号码');
            }
        });
        //点击确认
        $('.boundPhoneBtn').click(function() {
            if (checkphone && checkyzm) {
                fn.postBoundPhone();
            }
            if (checkphone == "a" && checkyzm == "a") {
                $('.error_phone').html(`<i></i>请输入相关内容`);
            }
        });
        //关闭
        $close = $('.user_title i');
        $close.click(function() {
            $.modal('close');
            location.reload();
            // window.location.href='/index.html';
        });

        // 绑定背景
        $('#sd_modal').click(function(){
            $.modal('close');
            location.reload();
        })
    },
    countDown(){
        var countdown=60;
        function settime() {
            if (countdown == 0) {
                $yzmBtn.attr("disabled",true);
                $yzmBtn.html("获取验证码");
                countdown = 60;
            } else {
                $yzmBtn.attr("disabled", 'disabled');
                $yzmBtn.html(`${countdown}s重新发送`);
                countdown--;
            }
        }
        setTimeout(function() {
            settime()
        },1000)
    },
    getRequestParam() {
        var theRequest = {};
        var str = document.location.search.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURI((strs[i].split("=")[1]));
        }
        return theRequest;
    },
    postRegister:function () {
        var vcode = fn.getRequestParam();
        var params = {
            userQq : $userQQ.val(),
            verifyCode : $yzmString.val(),
        };
        if(vcode.vcode){
            if(vcode.vcode.length == 32){
                vcode.vcode && (params.recommendCode = vcode.vcode);
            }else {
                $('.error_user_qq').html(`<i></i>邀请链接有误`);
                return;
            }
        }
        util.kAjax(REGISTER,params,function (res) {
            $('.error_user_qq').html(`<i></i>请点击<a href="http://www.mail.qq.com"
                                        style="color:red;text-decoration: underline;" target="_blank">前往邮箱</a>完成注册`);
            fn.freshYzm();
            $yzmString.val(' ');
        },function (res) {
            $('.error_user_qq').html(`<i></i>${res}`);
            fn.freshYzm();
            $yzmString.val(' ');
        })
    },
    postLogin:function () {
        var params = {
            userName : $loginQQ.val(),
            userPass : $loginPwd.val(),
            loginType:1
        };
        /**
         * 记住账号
         * loginName : 登录名称
         */
        if($('.remember')[0].checked){
            util.cookie.set('loginName',params.userName);
        }else{
            util.cookie.delete('loginName');
        }

        util.kAjax(LOGIN,params,function (res) {
            // 处理NODE登录校验session

            util.cookie.set('NSESSIONID', res.data.sessionId)

            $('.error_login_qq').html(`<i class="ok"></i>登录成功`);
            if(res.data.userPhone){

                setTimeout(function () {
                    location.reload();
                    // window.location.href='/index.html';
                },500);
            }else {
                $.modal('close');
                fn.boundPhone();
            }

            /**
             * 登录成功，储存cookie
             * userName  : 用户名称
             * loginName : 登录名称
             * userHead  : 用户头像
             */
            util.cookie.set('userName',res.data.userPetname || '深度会员');
            util.cookie.set('userHead',res.data.userHead);
            util.setCollectCookie(res.data.collectMap);
        },function (res) {
            console.log(res);
            $('.error_login_qq').html(`<i></i>${res}`)
        },true)
    },
    postFindPwd:function (fun) {
        var params = {
            userQq : $userQQ.val(),
            verifyCode : $yzmString.val()
        };
        util.kAjax(FINDPASSBYMAIL,params,function (res) {
            $('.alert').addClass('on');
            fun && fun(true);
            fn.freshYzm();
        },function (res) {
            $('.error_user_qq').html(`<i></i>${res}`);
            fn.freshYzm();
        });
    },
    postCode:function () {
        var param = {
            phone : $boundPhone.val()
        };
        util.kAjax(REGISTVERIFYCODE,param,function (res) {
            // fn.countDown();
        },function (res) {
            $('.error_phone').html(`<i></i>${res}`);
        })
    },
    postBoundPhone:function () {
        var params = {
            phone : $boundPhone.val(),
            verifyCode:$yzmString.val()
        };
        util.kAjax(BOUNDPHONE,params,function (res) {
            $('.error_phone').html(`<i class="ok"></i>绑定成功`);
            setTimeout(function () {
                location.reload();
               // window.location.href = '/index.html';
            },500);
        },function (res) {
            $('.error_phone').html(`<i></i>${res}`);
        });
    },
    register:{
        bind:function(){
            fn.initYzmImg();
            fn.checkQQ();
            fn.freshYzm();
            fn.checkYzm();
            fn.checkPwd();
            fn.checkLoginQQ();
            fn.tab();
            //点击弹框
            $('body').on('click', '.showLoginModal', function(){
                fn.pop_login();
            });

            //进入注册
            $('.showRegModal').on('click', function(){
                fn.pop_reg();
            });
        }
    },
    // 弹出登录
    pop_login(){
        fn.showModal();
        fn.check();
    },
    // 弹出注册
    pop_reg(){
        fn.pop_login();
        $('.user_title_regist').trigger('click');
    },
    // 校验是否有记住账号
    check(){
        /**
         * 有记住的账号
         */
        var loginName = util.cookie.get('loginName');
        if(loginName){
            $('.loginQQ').val(loginName);
            $('.checkbox.mb20 input')[0].checked = true;
        }
    }
};

// $(function(){
//     fn.register.bind();
// });

export {fn as auth}



// WEBPACK FOOTER //
// ./src/service/auth.js